import React from 'react';
import { BorderedBlock } from '@shared/ui/common/BorderedBlock';
import { ForecastPreview } from '@features/products/components/forecast-preview';

interface ProductForecastBlockProps {
  productId: string;
  forecastGradeFallback?: string;
  onViewInTimeTravel: () => void;
}

const ProductForecastBlock: React.FC<ProductForecastBlockProps> = ({
  productId,
  forecastGradeFallback,
  onViewInTimeTravel,
}) => (
  <BorderedBlock header="Forecast">
    <ForecastPreview
      productId={productId}
      forecastGradeFallback={forecastGradeFallback}
      onViewInTimeTravel={onViewInTimeTravel}
    />
  </BorderedBlock>
);

export default ProductForecastBlock;
